(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.from((r||document).querySelectorAll(s))}

  async function fetchCart(){const r=await fetch('/cart.js');return r.json()}
  async function addToCart(id,qty){
    const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:id,quantity:qty||1})});
    if(!r.ok){alert('Could not add to cart');return}
    await renderDrawer();openDrawer();
  }
  async function changeQty(key,qty){
    await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    await renderDrawer();
  }
  function money(c){return 'R'+(c/100).toFixed(2)}

  async function renderDrawer(){
    const cart=await fetchCart();
    const cnt=$('.cart-count');if(cnt){cnt.textContent=cart.item_count;cnt.style.display=cart.item_count>0?'inline-flex':'none'}
    const items=$('#drawer-items'),total=$('#drawer-total');
    if(!items)return;
    if(cart.item_count===0){items.innerHTML='<p style="color:var(--muted);text-align:center;padding:40px 0">Your cart is empty</p>';total.textContent='R0.00';return}
    items.innerHTML=cart.items.map(i=>`
      <div class="item">
        <img src="${i.image||''}" alt="">
        <div class="info">
          <div class="name">${i.product_title}</div>
          <div class="price">${money(i.final_line_price)}</div>
          <div style="margin-top:8px;display:flex;gap:6px;align-items:center">
            <button class="btn btn-ghost" style="padding:2px 8px" data-act="dec" data-key="${i.key}">-</button>
            <span>${i.quantity}</span>
            <button class="btn btn-ghost" style="padding:2px 8px" data-act="inc" data-key="${i.key}" data-qty="${i.quantity}">+</button>
            <button class="btn btn-ghost" style="padding:2px 8px;margin-left:auto" data-act="rm" data-key="${i.key}">Remove</button>
          </div>
        </div>
      </div>`).join('');
    total.textContent=money(cart.total_price);
    $$('#drawer-items [data-act]').forEach(b=>b.addEventListener('click',()=>{
      const k=b.dataset.key,a=b.dataset.act;
      if(a==='inc')changeQty(k,parseInt(b.dataset.qty)+1);
      if(a==='dec'){const cur=b.parentElement.querySelector('span');changeQty(k,Math.max(0,parseInt(cur.textContent)-1))}
      if(a==='rm')changeQty(k,0);
    }));
  }

  function openDrawer(){$('.drawer').classList.add('open');$('.drawer-overlay').classList.add('open')}
  function closeDrawer(){$('.drawer').classList.remove('open');$('.drawer-overlay').classList.remove('open')}

  document.addEventListener('click',e=>{
    const add=e.target.closest('[data-add-to-cart]');
    if(add){e.preventDefault();addToCart(add.dataset.addToCart,1);return}
    if(e.target.closest('.cart-btn')){e.preventDefault();renderDrawer();openDrawer();return}
    if(e.target.closest('[data-close-drawer]')||e.target.classList.contains('drawer-overlay'))closeDrawer();
    const co=e.target.closest('[data-checkout]');if(co){e.preventDefault();window.location.href='/checkout'}
  });

  renderDrawer();
})();

/* Hero WebGL aurora shader */
(function(){
  function init(){
    var canvas=document.querySelector('.hero-canvas');if(!canvas)return;
    var gl=canvas.getContext('webgl')||canvas.getContext('experimental-webgl');
    if(!gl){canvas.style.background='radial-gradient(ellipse at 50% 40%, rgba(26,183,234,.25), transparent 60%)';return}
    function resize(){var d=window.devicePixelRatio||1;canvas.width=canvas.clientWidth*d;canvas.height=canvas.clientHeight*d;gl.viewport(0,0,canvas.width,canvas.height)}
    var vs='attribute vec2 p;void main(){gl_Position=vec4(p,0.,1.);}';
    var fs='precision highp float;uniform vec2 r;uniform float t;'+
      'vec3 hash3(vec2 p){vec3 q=vec3(dot(p,vec2(127.1,311.7)),dot(p,vec2(269.5,183.3)),dot(p,vec2(419.2,371.9)));return fract(sin(q)*43758.5453);}'+
      'float n(vec2 p){vec2 i=floor(p),f=fract(p);f=f*f*(3.-2.*f);'+
      'float a=hash3(i).x,b=hash3(i+vec2(1,0)).x,c=hash3(i+vec2(0,1)).x,d=hash3(i+vec2(1,1)).x;'+
      'return mix(mix(a,b,f.x),mix(c,d,f.x),f.y);}'+
      'void main(){vec2 uv=(gl_FragCoord.xy-.5*r)/r.y;'+
      'float v=0.;vec2 q=uv*1.5;'+
      'for(int i=0;i<5;i++){v+=n(q+t*.05)*.5;q*=1.8;}'+
      'vec3 c1=vec3(.04,.07,.12);'+
      'vec3 c2=vec3(.1,.72,.92);'+
      'vec3 c3=vec3(.45,.2,.85);'+
      'float g=smoothstep(.2,.9,v);'+
      'vec3 col=mix(c1,c2,g*.7);col=mix(col,c3,smoothstep(.6,1.,v)*.5);'+
      'float vig=smoothstep(1.2,.2,length(uv));col*=vig;'+
      'gl_FragColor=vec4(col,1.);}';
    function sh(t,s){var x=gl.createShader(t);gl.shaderSource(x,s);gl.compileShader(x);return x}
    var pr=gl.createProgram();gl.attachShader(pr,sh(gl.VERTEX_SHADER,vs));gl.attachShader(pr,sh(gl.FRAGMENT_SHADER,fs));gl.linkProgram(pr);gl.useProgram(pr);
    var b=gl.createBuffer();gl.bindBuffer(gl.ARRAY_BUFFER,b);gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,-1,1,1,-1,1,1]),gl.STATIC_DRAW);
    var loc=gl.getAttribLocation(pr,'p');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
    var uR=gl.getUniformLocation(pr,'r'),uT=gl.getUniformLocation(pr,'t');
    resize();window.addEventListener('resize',resize);
    var start=performance.now();
    function draw(){var t=(performance.now()-start)/1000;gl.uniform2f(uR,canvas.width,canvas.height);gl.uniform1f(uT,t);gl.drawArrays(gl.TRIANGLES,0,6);requestAnimationFrame(draw)}
    draw();
  }
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
